<template>
  <div class="flex items-center gap-2">
    <button
      class="text-sm bg-blue-100 text-blue-700 px-3 py-1 rounded-lg font-semibold hover:bg-blue-200 transition-colors"
      @click="switchLang"
    >
      {{ props.pageLang === 'en' ? 'العربية' : 'English' }}
    </button>
  </div>
</template>

<script setup lang="ts">
const props = defineProps<{
  pageLang: string
}>()

const emits = defineEmits(['switchLang'])

const switchLang = () => emits('switchLang')
</script>
